import KT01BaseLayout from "general/components/BaseLayout/KT01BaseLayout";
import SaleReconciliationListScreen from "./screens/SaleReconciliationListScreen";
import { Route, Routes } from "react-router-dom";
import SaleReconciliationDetailScreen from "./screens/SaleReconciliationDetailScreen";
import AgencySaleOrderListScreen from "features/Agency/screens/AgencySaleOrderListScreen";

function SaleReconciliationReport(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0 pb-4">
                <Routes>
                    <Route
                        path=""
                        element={
                            <SaleReconciliationListScreen />
                        }
                    />
                    <Route
                        path="/order/*"
                        element={
                            <AgencySaleOrderListScreen showFullUI={false} />
                        }
                    />
                    <Route path="/:reconciliationId" element={<SaleReconciliationDetailScreen />} />
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default SaleReconciliationReport;
